/**
  @Description: 疾病覆盖
 * @Date: 2024-01-27 09:58:13
 */
import { nextTick } from 'vue';
export const selfAdaption = async (TaskRef, ContentRef, scale) => {
  await nextTick(() => {
    const parent = TaskRef.value.parentNode as HTMLDivElement;
    if (!parent) return;
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;
    const contentWidth = ContentRef.value.offsetWidth;
    const constHeight = ContentRef.value.offsetHeight;
    scale.value = Math.min(
      1,
      parentWidth / contentWidth,
      parentHeight / constHeight == 0 ? 1 : parentHeight / constHeight
    );
  });
};
